import React from 'react';
import PropTypes from 'prop-types';
import './style';

const Select = (props) => {
  const {
    id,
    label,
    selected,
    disabled,
    icon,
    onClick,
    width,
    className,
    ...attr
  } = props;

  return (
    <div
      className={`select-wrapper flex items-center justify-center gap-2.5 px-3 py-2.5${selected ? ' selected' : ''}${disabled ? ' disabled' : ''} ${className}`}
      onClick={(e) => onClick({ id, label }, e)}
      {...(width && ({ style: { width } }))}
      {...attr}
    >
      {icon}
      {label}
    </div>
  );
};

Select.propTypes = {
  id: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  selected: PropTypes.bool,
  icon: PropTypes.element,
  onClick: PropTypes.func,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

Select.defaultProps = {
  id: null,
  label: '',
  selected: false,
  icon: null,
  onClick: () => null,
  width: 240,
  className: '',
  disabled: false,
};

export default Select;